///
/// typescript 형식을 따르기 위해 window 객체에 config 타입 정의
///
declare global {
  interface Window {
    config: {};
  }
}

let Config = <any>{}; /// 프로그램 환경설정 내용 저장 변수

///
/// config.js 파일에서 설정된 내용이 없는 경우,
/// 기본적으로 설정되는 Default값 지정(아직 없음)
///
const appDefaultConfig = {};

///
/// config.js에 설정되어있는 프로그램 환경설정 내용을 Config 변수에 저장한다.
///
if (window && window.config !== undefined) {
  Config = window.config || {};
}

Config = Object.assign({}, appDefaultConfig, Config);

///
/// 프로그램 환경설정 변수 Export
///
export default Config;
